import { App } from "vue";
import { humanizeFileSize } from "../filters/humanize-file-size.filter";
import { formatMoney, moneyToChinese,formatMoneyZero } from "../filters/money.filter";

export function setupGlobalFilters(app: App) {
  app.config.globalProperties.$filters = {
    humanizeFileSize,
    formatMoney,
    moneyToChinese,
    formatMoneyZero,
  };
}
